import { Controller } from "@hotwired/stimulus"
import { getCloudFrontKeyPairId } from "../vendor/cloudfront-utils.js"

// Connects to data-controller="container-image-loader"
// Loads CloudFront images with container-based sizing (used in practice_passages/take)
export default class extends Controller {
  static values = {
    itemUrl: String,
    policy: String,
    signature: String
  }

  get keyPairId() {
    return getCloudFrontKeyPairId()
  }

  connect() {
    this.loadImage()
  }

  loadImage() {
    if (!this.hasItemUrlValue) return

    // Extract item ID: split by /, take second part, remove .png
    const item = this.itemUrlValue.split('/')[1].replace(".png", "")
    const cover = document.getElementById(item)
    const target = document.getElementById(item + "-alt")

    if (!cover || !target) {
      console.warn(`[container-image-loader] Could not find elements for item: ${item}`)
      return
    }

    // Calculate buffer based on whether last char is a number
    const lastChar = item.charAt(item.length - 1)
    const buffer = isNaN(parseInt(lastChar)) ? 0 : 25

    // Get container width (4 levels up from cover)
    const container = cover.parentElement?.parentElement?.parentElement?.parentElement
    if (!container) {
      console.warn(`[container-image-loader] Could not find container for item: ${item}`)
      return
    }

    const containerWidth = container.offsetWidth - buffer
    target.style.width = `${containerWidth}px`
    cover.style.width = `${containerWidth}px`

    // Build CloudFront signed URL
    const imageUrl = `https://cdn.lsatengine.com/Questions/${this.itemUrlValue}?Policy=${this.policyValue}&Signature=${this.signatureValue}&Key-Pair-Id=${this.keyPairId}`
    target.src = imageUrl

    // Set cover height based on aspect ratio when image loads
    target.onload = () => {
      const ratio = target.offsetWidth / target.naturalWidth
      const newHeight = (target.naturalHeight * ratio) + 1
      cover.style.height = `${newHeight}px`
    }
  }
}
